import { useQuery } from '@tanstack/react-query';

import { leagueKeys } from '@/hooks/league/leagueKeys';
import { getRecommendedLeaguesController } from '@/interface-adapters/controllers/leagues/get-recommended-leagues.controller';

export const useGetRecommendedLeaguesQuery = () => {
	return useQuery({
		queryKey: leagueKeys.recommendedAll(),
		queryFn: () => getRecommendedLeaguesController()
	});
};
